import autoCompleteAddress from "../functions/autoCompleteAddress";
import autoCompleteEmailDomains from "../functions/autoCompleteEmailDomains";
import enforceAtLeastOneCheckbox from "../functions/enforceAtLeastOneCheckbox";
import { initializeProfileForms } from "../functions/initializeProfileForms";
import {
  displayProgressInputForm,
  realTimeValidation,
  showAlertBeforeLeaves,
} from "../functions/forms";
import { showHideData } from "../functions/others";
import { toggleArticleDetailVisibility } from "../functions/toggleArticleDetailVisibility";
import toggleMessageAccordion from "../functions/toggleMessageAccordion";
import triggerEcommerceEntryEvent from "../functions/triggerEcommerceEntryEvent";

/* ------------------------------------------------------------------
*  ※ 拡散用ページとの共通仕様はcommon_with_spreadに定義
*    （このファイルは、通常応募フォームでのみ適用させるもの）
*
*   なお、bodyのclassは、あえてnewのみにしている。
*   応募時にバリデーションなどで弾かれた場合、createアクションにてnewのページがrenderされるが、その考慮は不要。
*   （cookiesのセットはnewの初回render時にすでに1度行っており、再度行う必要はないため）
*  WARNING:
*  応募ページ関連のcreateアクション (例：app/controllers/contacts_controller.rb)では、
*  フォーム送信後に `render :complete` を使用してレスポンスを返す仕様になっている。
*  そのため、新しいリダイレクトは発生せず、同じリクエスト内で完了ページが描画される。
*  この挙動により、newページ向けの`.ready()`ハンドラで定義された JavaScriptは完了ページでは自動的に実行されない。
*  (.ready() はページ読み込み時に一度だけ実行されるため、renderによって描画される完了ページでは再実行されない点に注意。)
--------------------------------------------------------------------- */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.contacts.new").length) return;
  // NOTE: 2023/6現在、日本郵政様のチラシ経由の応募の計測用途のみ
  //       Rails側で応募時にutm情報を使えるよう、LocalStorageからcookiesに情報を移している
  const utmKeys = ["utm_campaign", "utm_medium", "utm_source"];
  utmKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) {
      Cookies.set(key, value); // 有効期限を設定せず、セッションクッキーの形にしている（応募時のみ必要となるクッキーのため）
    }
  });
  // NOTE: esbuild移行時に応募フォーム周りのロジックがわかりやすくなるようにディレクトリを配置するなど凝結度を考慮する
  autoCompleteEmailDomains();
  toggleMessageAccordion();
  autoCompleteAddress();
  enforceAtLeastOneCheckbox();
  showAlertBeforeLeaves();
  realTimeValidation("#jsNewContact");
  displayProgressInputForm("#jsNewContact", ".jsRemainRequiredFieldCount");
  toggleArticleDetailVisibility(); // NOTE: ABテスト用：応募ページの改良
  showHideData("#jsShowHideDatasButton", "li.jsHideData", "jsHideData");
  showHideData(".jsShowHideAreasButton", "li.jsHideArea", "jsHideArea");
  triggerEcommerceEntryEvent(
    "gtm_ecommerce_begin_checkout",
    "gtmEntryArticle",
    "person"
  );
});

$(() => {
  if (!$("body.contacts.sp_new_preview").length) return;
  toggleMessageAccordion();
  toggleArticleDetailVisibility();
});

$(() => {
  if (!$("body.contacts.create").length) return;
  // NOTE: 応募後は計測不要となるため削除している
  //       （対象のキーがない場合でもエラーにならない）
  localStorage.removeItem("utm_campaign");
  localStorage.removeItem("utm_medium");
  localStorage.removeItem("utm_source");
  initializeProfileForms();
  // NOTE: 応募完了のeコマースイベント
  triggerEcommerceEntryEvent(
    "gtm_ecommerce_purchase",
    "gtmEntryArticleComplete",
    "person"
  );
});
